// @flow

import { connect } from 'react-redux';
import * as Selectors from '../selectors';
import AIReportsPage from '../components/pages/ai-reports';

function mapStateToProps(state, ownProps) {
  const { match } = ownProps || {};
  const editReportId = match && match.params && match.params.reportId;
  const originalReport = editReportId
    ? Selectors.getOneReport(editReportId, state)
    : null;
  return { ...ownProps, originalReport };
}

export default connect(mapStateToProps)(AIReportsPage);
